export const darkTheme = {
    bg: "#0d1f2d", surface: "#132637", border: "#1e3d56",
    text: "#e8f4f8", textMuted: "#8ab0c4", textFaint: "#4d7a94",
    accent: "#2a9d8f", accentBg: "#0d3330", accentText: "#4ecdc4",
    danger: "#e05c6a", success: "#2a9d8f", inputBg: "#0d1f2d", navActive: "#0d3330",
};

export const lightTheme = {
    bg: "#f0f5f9", surface: "#ffffff", border: "#dce8f0",
    text: "#1a2e44", textMuted: "#4a6a85", textFaint: "#8aaabf",
    accent: "#1a3a5c", accentBg: "#e8f0f7", accentText: "#1a3a5c",
    danger: "#c0392b", success: "#2a9d8f", inputBg: "#f5f9fc", navActive: "#dceaf5",
};